module.exports = __webpack_public_path__ + "fonts/Muli-Black.47b82930.eot";